import { Controller } from "@hotwired/stimulus";

export default class Sound extends Controller {
  static values = {
    url: String,
    playing: Boolean,
  };

  static targets = ["play", "pause"];

  connect() {
    this.sound = new Audio(this.urlValue);
    this.sound.onended = () => {
      this.playingValue = false;
      this.playTarget.classList.remove("hidden");
      this.pauseTarget.classList.add("hidden");
    }
  }

  play() {
    this.sound.play();
    this.playingValue = true
    this.playTarget.classList.add("hidden");
    this.pauseTarget.classList.remove("hidden");
  }

  pause() {
    this.sound.pause();
    this.playingValue = false
    this.playTarget.classList.remove("hidden");
    this.pauseTarget.classList.add("hidden");
  }

  reset() {
    this.sound.pause();
    this.sound.load();
  }

  volume(params) {
    this.sound.volume = params.volume;
  }

  muted(params) {
    this.sound.muted = params.muted;
  }

  loop(params) {
    this.sound.loop = params.loop;
  }
}

